import type { Theme as GenerativeUITheme } from "@openuidev/react-ui";

type ThemeConfig = {light: Partial<GenerativeUITheme>, dark: Partial<GenerativeUITheme>}
export const background: ThemeConfig = {
    light: {
        
    },
    dark: {
        
    }
}

export const border: ThemeConfig = {
    light: {
        borderDefault: "var(--primary-200)"
    },
    dark: {
        borderDefault: "var(--primary-200)"
    }
}

export const toastStyle = {
    backgroundColor: 'var(--structural-neutral-1)',
    color: 'var(--popover-foreground)',
    border: '1px solid var(--border)',
}
